
// src/connects/unread-timeline-page.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import lifecycle from '../helpers/lifecycle'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import find from 'lodash/find'

export const mapStateToProps = (state, ownProps)=> {
  return {
    isFetching: state.subDiaries.isFetching,
    isFetchFailed: state.subDiaries.isFetchFailed,
    diaries: state.subDiaries.items,
    group: ownProps.params.group_id && find(state.groups.items, (item)=> item.group_id == ownProps.params.group_id) || undefined,
    user: state.user.current,
    likeConfig: state.likes.likeConfig,
    rightSidePage: state.rightSidePage.name,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    // 未読の投稿に対しては無限スクロールは行わず、まとめて50剣を先に取得してしまうように
    // 開封処理が行われることで未読のリストが変動してしまいoffsetが意味をなさないため
    willMount: (props)=> {
      dispatch(actions.fetchSubDiaries(props.params.group_id, 0, { unread: true, length: 50 }))
    },

    readDiary: (props, diary)=> {
      const read = diary.user && diary.user.user_id == props.user.user_id || diary.readers && find(diary.readers, (reader)=> reader.user.user_id == props.user.user_id)
      !read && dispatch(actions.markDiaryRead(diary.diary_id))
    },

    willUnmount: ()=> {
      dispatch(actions.clearSubDiaries())
      dispatch(actions.fetchGroupUnreadCount(ownProps.params.group_id))
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/unread-timeline-page.js